export default __webpack_public_path__ + "static/media/martin_edenor.c2a02fa9.jpg";